import { IChildWorksheetSpaceType } from 'spw-redux/modules/calculators/types';
import { IProjectSpaceType } from 'spw-redux/modules/space_types/types';
import {
  IProjectSpaceTypeCategory,
  IProjectSpaceTypeSubcategory,
} from 'spw-redux/modules/projects/types';
import WorksheetRow from '../../../models/WorksheetRow';
import { PlainProgramScenario } from '../../../models/Scenario';
import { PlainWorksheet } from '../../../models/Worksheet';

export interface IWorksheetState {
  showRemoveSpaceTypeDialog: boolean;
  selectedRow: WorksheetRow | null;
  selectedSpaceTypeCategory:
    | IProjectSpaceTypeCategory
    | IProjectSpaceTypeSubcategory;
  selectedSpaceType: IProjectSpaceType | null;
  selectedChildSpaceType?: IChildWorksheetSpaceType | null;
  scenariosUsingSpaceTypeOrCategory: PlainProgramScenario[];
  worksheetsUsingSpaceTypeOrCategory: {
    byId: {
      [key: string]: PlainWorksheet;
    };
  };
  canDeleteSpaceType: CanDeleteSpaceTypeEnum;
  hideAllMode: boolean;
  decimalsAreEnabled?: boolean;
}

export type WorksheetDefaultCategory =
  | 'meetingSpaces'
  | 'individualWorkspaces'
  | 'amenitySpaces'
  | 'supportSpaces'
  | 'customCategory'
  | 'privateOffices';

export enum CanDeleteSpaceTypeEnum {
  'QUERYING',
  'TRUE',
  'FALSE',
}
